var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('rv-agreement-template',{attrs:{"title":_vm.current.title,"text":_vm.text,"curAgreement":_vm.current.value,"agreementSlt":_vm.agreements},on:{"selectChange":_vm.selectChange}},[_c(_vm.current.component,{tag:"component"})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }